import { useContext, useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import ApiContext from "src/provider/API/call-service";
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import { AbsoluteContainer, AppSpan, Button, CustomContainer, FlexRow, GridContainer, ScreenContainer, ScreenTitle } from "src/style"
import utility from "src/utils/utility"
import helpers from 'src/utils/helpers'
import { SearchInput, ServerSideTable } from 'src/component'
import { companiesColumn, companiesData } from 'src/utils/tableLayout'
import { Company } from 'src/model'
import { NewCompanyBasicDetails, NewCompanyLocation, SuspensionReason } from "src/popup"
import { IoMdAdd } from "react-icons/io";

const Companies: React.FC<any> = () => {
    const navigate = useNavigate()
    const {setInfoProperty} = useContext(AppInfoContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {API} = useContext(ApiContext)
    const [navPosition, setNavPosition] = useState(0)
    const [companiesInfo, setCompaniesInfo] = useState<any>(null)
    const [companies, setCompanies] = useState<any[]>([])
    const [mockTableData, setMockTableData] = useState<any[]>([])
    const [selectedCompanyToAction, setSelectedCompanyToAction] = useState<any>(null)
    const [view, setView] = useState('')

    useEffect(() => {
        handleFetchCompanies()
    }, [navPosition])

    async function handleFetchCompanies (pageNumber = 1, pageSize = 10) {
        const response = await API.getOrganizations({
            page: pageNumber, 
            size: pageSize,
            status: navPosition != 0 ? 'SUSPENDED' : 'ACTIVE'
        })
        if (response) {
            setCompaniesInfo(response)
            setCompanies(response.data)
            setMockTableData(response.data)
        }
    }

    function handleDataSearching (e: React.ChangeEvent<HTMLInputElement>) {
        const filteredData = helpers.searchTableData(companies, e.target.value)
        setMockTableData(filteredData)
    }

    async function handleRowClick (data: Company) {
        await setInfoProperty('selectedCompany', data)
        navigate('/dashboard/companies/company-details')
    }

    function handleSelectedOption (data: Company, option: string) {
        if (option === 'view') handleRowClick(data)
        else if ('unsuspend') handleCompanyActivation(data.id)
        else {
            setSelectedCompanyToAction(data)
            setView('suspension-reason')
        }
    }

    function handleSuspensionConfirmation (reason: string) {
        decisionBox.show(
            'Are you sue you want to suspend this company?',
            () => handleCompanySuspension(reason),
            null,
            'negative',
            'Suspend'
        )
    }

    async function handleCompanySuspension (reason: string) {
        const response = await API.suspendCompany(selectedCompanyToAction?.id, reason)
        if (response) handleFetchCompanies()
    }

    async function handleCompanyActivation (organizationId: string) {
        const response = await API.unSuspendCompany(organizationId)
        if (response) handleFetchCompanies()
    }
    
    return (
        <>
            <ScreenContainer padding='2.5'>
                <FlexRow
                    justifyContent="space-between" gap="2.5" 
                    wrap="wrap" bottomMargin='4'
                >
                    <CustomContainer width="auto" sizeUnit="">
                        <ScreenTitle 
                            color='#333333' 
                            textSize='2.4' 
                            fontWeight='700'
                        >
                            Companies
                        </ScreenTitle>
                        <AppSpan>List of all companies</AppSpan>
                    </CustomContainer>
                    <Button 
                        width='20.5' 
                        hoverBgColor='#ffffff' 
                        hoverColor='#5627FF'
                        borderColor='#5627FF'
                        onClick={() => setView('company-basic-details')}
                    >
                        <IoMdAdd fontSize='1.9rem' style={{marginRight: '1rem'}} />
                        Add New Company
                    </Button>
                </FlexRow>
                <FlexRow justifyContent='space-between' wrap='wrap' gap='2.5'>
                    <GridContainer
                        className='scrollable-container toggle-border-bottom'
                        height="3.6" width='32.5'
                    >
                        <AbsoluteContainer 
                            width={navPosition === 0 ? '12' : '18'} 
                            top="0" left={`${navPosition}`}
                        >
                            <CustomContainer 
                                bgColor="#F0ECFF" height="3.6" 
                                borderBottomColor='#5627FF' borderWidth='4.5'
                            />
                        </AbsoluteContainer>
                        <FlexRow
                            alignItems='flex-start'
                            gap='1'
                            style={{zIndex: '2'}}
                        >
                            <GridContainer 
                                width='11.6' rightMargin='1.5' 
                                hoverBgColor={navPosition === 0 ? '' : '#F0ECFF'}
                                onClick={() => setNavPosition(0)}
                                className='toggled-item'
                            >
                                <AppSpan  
                                    cursor="pointer"
                                    fontWeight={navPosition === 0 ? "700" : "400"}
                                    color={navPosition === 0 ? "#181D27" : "#828282"}
                                >
                                    All Companies
                                </AppSpan>
                            </GridContainer>
                            <GridContainer 
                                width='18' rightMargin='1.5'
                                hoverBgColor={navPosition === 14 ? '' : '#F0ECFF'}
                                onClick={() => setNavPosition(14)}
                                className='toggled-item'
                            >
                                <AppSpan 
                                    cursor="pointer"
                                    fontWeight={navPosition === 14 ? "700" : "400"}
                                    color={navPosition === 14 ? "#181D27" : "#828282"}
                                >
                                    Suspended Companies
                                </AppSpan>
                            </GridContainer>
                        </FlexRow>
                    </GridContainer>

                    <SearchInput onChange={handleDataSearching} />
                </FlexRow>

                <CustomContainer topMargin='4' className="no-user-container">
                    <ServerSideTable
                        tableColumns={companiesColumn(handleSelectedOption)}
                        tableData={mockTableData}
                        dataFetchMethod={handleFetchCompanies}
                        totalRows={companiesInfo?.totalResults}
                        noDataText='No Companies'
                        noRadius
                        onRowClickMethod={handleRowClick}
                    />
                </CustomContainer>
            </ScreenContainer>
            { view === 'suspension-reason' &&
                <SuspensionReason
                    close={() => setView('')}
                    onSuspendClick={(reason: string) => handleSuspensionConfirmation(reason)} 
                />
            }
            { view === 'company-basic-details' &&
                <NewCompanyBasicDetails
                    close={() => setView('')} 
                    next={() => setView('company-location')}
                />
            }
            { view === 'company-location' &&
                <NewCompanyLocation 
                    close={() => setView('')} 
                    back={() => setView('company-basic-details')}
                    fetchCompanies={handleFetchCompanies}
                />
            }
        </>
    )
}

export default utility.routeData('companies', 'Companies', <Companies/>)